/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Cta_TitleInputs */

const en_rd_cta_title = /** @type {(inputs: Rd_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix it step by step`)
};

const id_rd_cta_title = /** @type {(inputs: Rd_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benahi selangkah demi selangkah`)
};

/**
* | output |
* | --- |
* | "Fix it step by step" |
*
* @param {Rd_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_cta_title = /** @type {((inputs?: Rd_Cta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Cta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_cta_title(inputs)
	return en_rd_cta_title(inputs)
});